export default __webpack_public_path__ + "static/media/QPQ.ac870bde.gif";